/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import  {
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faXTwitter,
    faYoutube,
    // faTwitter,
} from "@awesome.me/kit-db56931b65/icons/classic/brands";

const brands = {
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faXTwitter,
    faYoutube,
    // faTwitter,
};

export {
    brands,
};
